import { createEntityAdapter } from '@reduxjs/toolkit';
import { ProductExtraFeeParams } from './productExtraFees.types';

const adapter = createEntityAdapter<ProductExtraFeeParams>();

export default adapter;
